import myEditor from './myEditor.vue'

const MyEditor = {
  install(Vue) {
    Vue.component(myEditor.name, myEditor)
  }
}

export default MyEditor
